<template>
  <div v-if="msg" class="fixed">
    <div class="tips">{{msg}}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_MSG } from "@/store/mutations.type";

export default {
  name: "Tips",
  computed: {
    ...mapGetters(["msg"])
  },
  data() {
    return {
      text: ''
    };
  },
  watch: {
    msg(){
      setTimeout(() => {
        this.$store.commit(SET_MSG,'')
      }, 1000)
    }
  }
};
</script>
